<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="stretch-to-parent">
    <div class="alerts-block">
        <div class="container p-0">
            <winde-alert-error></winde-alert-error>
        </div>
    </div>

    <div class="stretch-to-parent picture-block">
        <div class="container picture-block__content">
            <h5 class="text-center picture-block__title mb-0">
                Introduction to the
                <span>Smarthaul™ Wireless Network Design Engine</span>
            </h5>
            Siklu Smarthaul™ Wireless Network Design Engine (WiNDE) automates the many tasks of designing a complete millimeter wave
            wireless network, reducing days of complex work and tedious details to hours. Intuitive and easy to use, the 5-steps wizard will
            swiftly guide a user with 40 years or 40 days of network experience, to efficiently complete the design.<br/>
            Key Features & Benefits:
            <ul class="mt-2 mb-2">
                <li>SaaS, no installs, constantly up to date</li>
                <li>Automated Topology Designs</li>
                <li>Complete RF planning and validation</li>
                <li>Integrated Bill of Material</li>
                <li>Deploy as Designed with WiNDE-generated Configuration Files for Siklu radios</li>
            </ul>
            <ng-container *ngIf="systemInfo$ | async as systemInfo">
                <p *windeHasAnyAuthority="[userAuthorities.ANONYMOUS]" class="mb-1">
                    <a [href]="systemInfo.registrationUrl" class="btn btn-success btn-sm" rel="noopener" target="_blank">
                        Click here to register
                    </a>
                </p>
                <strong>
                    We welcome your comments and suggestions to
                    <a [href]="'mailto: ' + systemInfo.supportEmail" class="text-success">{{ systemInfo.supportEmail }}</a
                    >.
                </strong>
            </ng-container>
        </div>
    </div>
</div>
